import React, { useState, useEffect, useContext } from "react";
import { Container, Spinner, Col } from "react-bootstrap";
import ActionComp from "../layouts/ActionComp";
import BreadcrumbComp from "../layouts/BreadcrumbComp";
import DisposalIntimation from "./AddEditDisposalIntimation.jsx";
import PendingApprovalDashboard from "./PendingApprovalDashboard";
import SentForApprovalDashboard from "./SentForApprovalDashboard";
import { AuthContext } from "../../contexts/AuthContext";
import { menuActions } from "../../store/menu-slice";
import { useDispatch } from "react-redux";
import { searchActions } from "../../store/grid-slice";
import "./DisposalIntimationDashboard.css";
import { getPendingData, getSentForApprovalData } from "../../services/pending-approver-service.js";
import DisposalIntimationApprove from "./DisposalIntimationApprove.jsx";

const DisposalIntimationDashboard = () => {
  const context = useContext(AuthContext);
  const userDetails = { userName: context.userName, role: context.role, userId: context.userId };
  const dispatch = useDispatch();
  const [action, setAction] = useState("");
  const [reload, setReload] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [resetFilter, setResetFilter] = useState(true);
  const [loading, setLoading] = useState(true);
  const [pendingApprovals, setPendingApprovals] = useState([]);
  const [sentForApproval, setSentForApproval] = useState([]);
  const [rowData, setRowData] = useState(null);

  const fetchDisposalIntimations = async () => {
    setLoading(true);
    try {
      // Get pending approvals based on user role, division, and location
      const pendingData = await getPendingData(userDetails.role, context.division, context.location, userDetails.userName);
      setPendingApprovals(pendingData);

      // Get sent for approval data
      const sentData = await getSentForApprovalData(userDetails.userId, userDetails.role, context.division, context.location);
      setSentForApproval(sentData);

      setResetFilter(!resetFilter);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };


  useEffect(() => {
    dispatch(menuActions.setMenu("Disposal Intimation"));
    dispatch(searchActions.setSearch(""));
  }, [reload, dispatch]);

  useEffect(() => {
    fetchDisposalIntimations();
  }, [reload]);

  const handleAdd = () => {
    setAction("Add");
    setShowForm(true);
  };

  return (
    <>
      {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
      <BreadcrumbComp />
      <Container fluid className="main-container">
        {!showForm && (
          <>
            <ActionComp
              label={"Add New Disposal Intimation"}
              handleAdd={handleAdd}
            />

            <div className="split-dashboard">
              <Col lg={6} className="left-panel">
                <PendingApprovalDashboard
                  data={pendingApprovals}
                  resetFilter={resetFilter}
                  setAction={setAction}
                  setShowForm={setShowForm}
                  setRowData={setRowData}
                />
              </Col>

              <Col lg={6} className="right-panel">
                <SentForApprovalDashboard
                  data={sentForApproval}
                  resetFilter={resetFilter}
                  setAction={setAction}
                  setShowForm={setShowForm}
                  setRowData={setRowData}
                  setReload={setReload}
                  reload={reload}
                />
              </Col>
            </div>
          </>
        )}

        {showForm && (action === "Approval" || action === "View") && (
          <DisposalIntimationApprove
            show={showForm}
            action={action}
            rowData={rowData}
            onHide={() => setShowForm(false)}
            setReload={setReload}
            reload={reload}
          />
        )}

        {showForm && !['Approval', 'View'].includes(action) && (
          <DisposalIntimation
            show={showForm}
            action={action}
            rowData={rowData}
            onHide={() => setShowForm(false)}
            setReload={setReload}
            reload={reload}
          />
        )}
      </Container>
    </>
  );
};

export default DisposalIntimationDashboard;
